export const isTextRTL = (text: string) => {
  const rtlCharsPattern = /[\u0590-\u05FF\u0600-\u06FF]/g;
  const ltrCharsPattern = /[a-zA-Z]/g;

  const rtlCount = ((text && text.match(rtlCharsPattern)) || []).length;
  const ltrCount = ((text && text.match(ltrCharsPattern)) || []).length;

  return rtlCount > ltrCount;
};
